import { useState } from 'react';
import { BrandFormFields } from '../../components/brands/BrandFormFields';
import { Button } from '../../components/ui/button';
import {
	Dialog,
	DialogBody,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogForm,
	DialogHeader,
	DialogTitle,
} from '../../components/ui/dialog';
import { emptyBrandDraft, useCreateBrand } from '../../hooks/useCreateBrand';

export function CreateBrandModal({
	open,
	onOpenChange,
	organizationId,
	onSuccess,
}: {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	organizationId: string;
	onSuccess?: () => void;
}) {
	const [draft, setDraft] = useState(emptyBrandDraft);
	const { create, loading } = useCreateBrand(organizationId);

	const resetForm = () => setDraft(emptyBrandDraft);

	const handleSubmit = async () => {
		if (!draft.name.trim() || loading) return;

		const { success } = await create(draft);
		if (!success) return;

		resetForm();
		onOpenChange(false);
		onSuccess?.();
	};

	return (
		<Dialog
			open={open}
			onOpenChange={(next) => {
				if (!next) resetForm();
				onOpenChange(next);
			}}
		>
			<DialogContent className="sm:max-w-md">
				<DialogHeader>
					<DialogTitle>Create brand</DialogTitle>
					<DialogDescription>Add a new brand to this organization.</DialogDescription>
				</DialogHeader>

				<DialogForm onSubmit={handleSubmit}>
					<DialogBody>
						<BrandFormFields value={draft} onChange={setDraft} autoFocus />
					</DialogBody>

					<DialogFooter>
						<Button
							type="button"
							variant="outline"
							onClick={() => {
								resetForm();
								onOpenChange(false);
							}}
						>
							Cancel
						</Button>
						<Button type="submit" disabled={!draft.name.trim() || loading}>
							{loading ? 'Creating...' : 'Create brand'}
						</Button>
					</DialogFooter>
				</DialogForm>
			</DialogContent>
		</Dialog>
	);
}
